"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
// This file is autogenerated by "make react_icons", do not edit it.
const React = tslib_1.__importStar(require("react"));
const Superscript = (props) => React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round", className: "icon icon-tabler icons-tabler-outline icon-tabler-superscript", ...props },
    React.createElement("path", { d: "M0 0h24v24H0z", stroke: "none" }),
    React.createElement("path", { d: "M5 7l8 10m-8 0l8-10M21 11h-4l3.5-4A1.73 1.73 0 0017 5" }));
exports.default = Superscript;
